/**
* @file 运营中心-旅游包车订单
* */
<template>
  <div id="order">
    <el-radio-group v-model="tabAction" style="margin-bottom: 15px">
      <el-radio-button label="all">全部</el-radio-button>
      <el-radio-button v-for="item in $const.HITCHHIKING" :key="item.value" :label="item.value">
        {{ item.label }}
      </el-radio-button>
    </el-radio-group>

    <custom-table :hasChannel="true" has-organization="true" ref="customTable" :customOptions="customOptions"
      :columns="columns" excel-type="OrderHitchRide" labelWidth="135" style="height: 95%" :columnsSettingShow="true">
      <template slot="table-operation" v-if="mixinUserInfo.type !== 3">
        <el-table-column label="操作" width="130" fixed="right" align="center">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text"
              v-if="[10, 20, 25, 35, 40].includes(row.status) && btnPreFn('orderHitchRide_cancel', false)"
              @click="actionFn({ type: 'cancel', row: row })">取消
            </el-button>
            <el-button type="text" v-if="[10].includes(row.status) && btnPreFn('orderHitchRide_assign', false)"
              @click="actionFn({ type: 'reassignment', row: row })">改派
            </el-button>
            <el-button type="text" v-if="btnPreFn('orderHitchRide_work', false)" @click="createKeSu(row)">客诉</el-button>
            <div
              v-if="((!btnPreFn('orderHitchRide_cancel', false) && !btnPreFn('orderHitchRide_assign', false)) || !([10, 20, 25, 35, 40].includes(row.status)) && !btnPreFn('orderHitchRide_work', false))">
              -</div>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="
          [
            'created',
            'finishTime',
            'reachTime',
            'refundTime'
          ].includes(item.prop)
        ">
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else-if="item.prop == 'orderNo'">
          <span class="link" @click="actionFn({ type: 'look', row: row })" @dblclick="$utils.dblclickCopy">{{
            row[item.prop] }}</span>
          <div>
            <el-tag :type="getStatusType(row.status)" size="mini">{{ row.status | filterConst('HITCHHIKINGDAN') }}</el-tag>
            <span style="margin-left: 4px;"> {{ row.channelName }}</span>
          </div>
        </template>
        <template v-else-if="item.prop == 'partnerOrderId'">
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] :
            "-" }}</span>
          <div>{{ row.channelAlias | filterConst("HITCHHIKINGCHANNEL") }}</div>
        </template>
        <template v-else-if="item.prop == 'licenseNo'">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
            @dblclick="$utils.dblclickCopy"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop == 'driverName'">
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
          <div @dblclick="$utils.dblclickCopy">{{ row.driverPhone }}</div>
        </template>

        <template v-else-if="item.prop === 'startCity'">
          <div>{{ row.startCity }} - {{ row.endCity }}</div>
          <el-tag :type="row.cityType == 1 ? 'warning' : 'success'" size="small">{{ row.cityType == 1 ? '城际' : '市内' }}线路</el-tag>
        </template>
        <template v-else-if="item.prop == 'earliestDepartureTime'">
          <span>{{ row.earliestDepartureTime | filterTime('YYYY/MM/DD HH:mm') }}</span>
          <!-- <div style="color: #999">{{ row.latestDepartureTime | filterTime }}</div> -->
        </template>
        <template v-else-if="item.prop === 'startPointName'">
          <div>{{ row.startPointName }}</div>
          <div style="color: #999">{{ row.startPointAddress }}</div>
        </template>
        <!-- <template v-else-if="item.prop == 'poolType'">
          <span :style="{ color: row.poolType == 1 ? '#409EFF' : '#909399' }">{{ row.poolType | filterConst("POOLTYPE")
            }}</span>
        </template> -->
        <template v-else-if="item.prop == 'realPhoneSuffix'">
          {{ row.realPhoneSuffix }} / {{ row.passengerNum }}人
          <el-tag :type="row.poolType == 1 ? 'primary' : 'success'" size="mini" style="margin-left: 4px;">{{ row.poolType == 1 ? '独享' : '拼车' }}</el-tag>
        </template>
        <template v-else-if="item.prop === 'endPointName'">
          <div>{{ row.endPointName }}</div>
          <div style="color: #999">{{ row.endPointAddress }}</div>
        </template>
        <template v-else-if="item.prop == 'amount'">
          <span class="util-money"> ¥{{ row.amount || 0 }} </span>
        </template>
        <template v-else-if="item.prop == 'cancelFee'">
          <span v-if="row.cancelFee">
            <span class="util-money">¥{{ row.cancelFee || 0 }}</span><span v-if="row.cancelRatio">({{ row.cancelRatio}}取消费率)</span>
          </span>
          <span class="util-money" v-else-if="row.refundAmount">{{ row.refundAmount }}元</span>
          <span v-else>-</span>
        </template>

        <template v-else-if="item.prop == 'commissionAmount'">
          <span class="util-money"> ¥{{ row.commissionAmount || 0 }} </span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-drawer :show-close="false" :visible.sync="show" destroy-on-close :close-on-click-modal="false"
      :before-close="handClose">
      <hitchhikingDetails @handClose="handClose" @handleComplaint="handleComplaint" v-if="show" :rowData="rowData">
      </hitchhikingDetails>
    </el-drawer>
    <el-dialog title="取消订单" :before-close="handClose" :visible.sync="showCancel" destroy-on-close
      :wrapperClosable="false" width="500px">
      <hitchhikingCancel @handClose="handClose" :rowData="rowData" v-if="showCancel"></hitchhikingCancel>
    </el-dialog>
    <!-- 改派 -->
    <orderReassign v-if="showReassign" :show="showReassign" :orderId="rowData.id" :loading="loading" @assign="assignFn"
      @close="handClose"></orderReassign>
    <!-- 客诉 -->
    <hitchhikingCreate ref="hitchhikingCreate"></hitchhikingCreate>
  </div>
</template>

<script>
import hitchhikingDetails from "./components/hitchhikingDetail.vue";
import hitchhikingCancel from "./components/hitchhikingCancel.vue";
import hitchhikingCreate from "./components/hitchhikingCreate.vue";
import orderReassign from "./components/orderReassign.vue";
import LicensePlate from "@/components/licensePlate";

export default {
  name: "order",
  components: {
    hitchhikingDetails,
    hitchhikingCancel,
    hitchhikingCreate,
    orderReassign,
    LicensePlate
  },
  data() {
    return {
      tabAction: "all",
      loading: false,
      refundFee: null,
      refundState: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/order/hitchRide/list",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "orderNo", name: "订单号", value: "" },
          {
            type: "select",
            field: "cityType",
            name: "顺风车类型",
            value: "",
            option: this.$const.HITCHHIKINGTYPE,
          },
          {
            type: "select",
            field: "poolType",
            name: "订单类型",
            value: "",
            option: this.$const.POOLTYPE,
          },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          {
            type: "input",
            field: "realPhoneSuffix",
            name: "乘客尾号",
            value: "",
          },
          {
            type: "datetime",
            field: "EarliestDepartureTime",
            dateProp: {
              start: "startEarliestDepartureTime",
              end: "endEarliestDepartureTime",
            },
            name: "最早出发时间",
            value: [],
          },
          {
            type: "datetime",
            field: "LatestDepartureTime",
            dateProp: {
              start: "startLatestDepartureTime",
              end: "endLatestDepartureTime",
            },
            name: "最晚出发时间",
            value: [],
          },
          {
            type: "datetime",
            field: "finishTime",
            dateProp: { start: "startFinishTime", end: "endFinishTime" },
            name: "完成时间",
            value: [],
          },
          {
            type: "datetime",
            field: "reachTime",
            dateProp: { start: "startReachTime", end: "endReachTime" },
            name: "乘客下车时间",
            value: [],
          },
          {
            type: "input",
            field: "partnerOrderId",
            name: "三方订单号",
            value: "",
          },
        ],
      },
      // 表头
      columns: [
        { prop: "orderNo", label: "订单号", width: 200 },
        { prop: "startCity", label: "城市/线路", minWidth: 120 },
        { prop: "startPointName", label: "上车位置", minWidth: 200 },
        { prop: "endPointName", label: "下车位置", minWidth: 200 },
        { prop: "earliestDepartureTime", label: "出发时间", minWidth: 140 },
        { prop: "realPhoneSuffix", label: "乘客", minWidth: 140 },
        { prop: "poolType", label: "是否拼车", minWidth: 80 },
        { prop: "amount", label: "订单金额", width: 100 },
        { prop: "cancelFee", label: "退改金额", minWidth: 180 },
        { prop: "commissionAmount", label: "司机收入", width: 90 },
        { prop: "licenseNo", label: "车辆号牌", width: 100 },
        { prop: "driverName", label: "司机信息", width: 100 },
        { prop: "created", label: "抢单时间", width: 140, hide: true },
        { prop: "finishTime", label: "完成/取消时间", width: 140 },
        { prop: "reachTime", label: "乘客确认下车时间", width: 140, hide: true },
        { prop: "partnerOrderId", label: "三方订单号", width: 120, hide: true },
        { prop: "refundTime", label: "退款时间", width: 140 },
      ],
      // 状态
      status: null,
      show: false,
      showCancel: false,
      rowData: {},
      clickTimeout: null,
      showReassign: false
    };
  },
  watch: {
    tabAction(val) {
      this.customOptions.params.page = 1;
      this.customOptions.params.status = val != "all" ? val : null;
      this.$refs.customTable.listFn();
    },
  },
  methods: {
    handleComplaint(row) {
      console.log('发起客诉', row);
      this.createKeSu(row);
    },
    // 客诉
    async createKeSu(row) {
      let url = '/api/v1/manage/hitchRide/work/order'
      let params = {
        orderId: row.id
      }
      const { code, data } = await this.$axios.get(url, params)
      if (code === 1) {
        if (data) {
          this.$message.warning('当前订单已有工单，正在为您跳转；')
          setTimeout(() => {
            this.$router.push({
              path: '/hitchRideWorkDetail',
              query: {
                id: data
              }
            })
          }, 1000);
        } else {
          this.$refs.hitchhikingCreate.show(row.id, row.organizationName)
        }
      }
    },
    // 改派
    async assignFn(row) {
      this.loading = true;
      try {
        const url = "/api/v1/manage/order/hitchRide/assign/again"
        const params = {
          id: this.rowData.id,
          vehicleId: row.vehicleId,
          driverId: row.driverId
        }
        const { code } = await this.$axios.post(url, params)
        if (code === 1) {
          this.$message.success('订单改派成功');
          this.showReassign = false;
          this.$refs.customTable.listFn();
        }
      } finally {
        this.loading = false;
      }
    },
    actionFn({ type, row }) {
      this.rowData = { ...row };
      clearTimeout(this.clickTimeout);
      this.clickTimeout = setTimeout(() => {
        switch (type) {
          case "look":
            this.show = true;
            break;
          case "cancel":
            this.showCancel = true;
            break;
          case "reassignment":
            this.showReassign = true;
            break;
        }
      }, 200);
    },
    /**
     * 状态改变
     */

    handClose() {
      this.rowData = {};
      this.show = false;
      this.showCancel = false;
      this.showReassign = false;
      this.$refs.customTable.listFn();
    },
    /**
     * 获取状态对应的颜色
     * @param {number} status - 订单状态
     * @returns {string} 颜色值
     */
    getStatusColor(status) {
      const item = this.$const.HITCHHIKINGDAN.find(value => value.value == status);
      return item ? item.color : '#909399';
    },
    getStatusType(status) {
      const item = this.$const.HITCHHIKINGDAN.find(value => value.value == status);
      return item ? item.type : 'info';
    },
  },
  created() {
    if (this.$route.query.status) {
      this.customOptions.params.status = this.$route.query.status;
      this.tabAction = this.customOptions.params.status;
    }
  },
};
</script>

<style scoped lang="less">
#order {
  .dialog_tips {
    color: red;
    margin: 10px 0 5px;
  }

  .result-dialog {
    .content {
      font-family: Source Han Sans SC, Source Han Sans SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      text-align: center;
      width: 100%;

      .time {
        margin: 10px 0;
      }

      .tips {
        font-size: 14px;
      }
    }

    .btn {
      width: 100%;
      margin-top: 16px;
    }

    /deep/ .el-dialog__body {
      padding: 0 20px 20px !important;
    }
  }

  /deep/ .el-drawer {
    width: 70% !important;
    overflow-x: hidden;
  }
}
</style>
